import { createSelector } from "reselect";
import { assessmentVersionSelector } from "src/selectors/config_selectors";

export const historyCauseEnabledSelector = createSelector(
  assessmentVersionSelector,
  version => {
    return version === "ML1";
  }
);
